import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
const Login = React.lazy(() => import("../pages/Authentication/Login"));
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));
const Register = React.lazy(() => import("../pages/Authentication/Register"));
const ForgetPwd = React.lazy(() => import("../pages/Authentication/ForgetPassword"));
const AuthLockScreen = React.lazy(() => import("../pages/Authentication/AuthLockScreen"));

// Dashboard
const Dashboard = React.lazy(() => import("../pages/Dashboard/index"));

const NewMaterialRequest = React.lazy(() => import("../pages/Material/NewMaterialRequest/NewMaterialRequest"));
const NewServiceRequest = React.lazy(() => import("../pages/Service/NewServiceRequest/NewServiceRequest"));
const MaterialRequestDashboard = React.lazy(() => import("../pages/Material/MaterialRequest/index"));
const ServiceRequestDashboard = React.lazy(() => import("../pages/Service/ServiceRequest/index"));
const MaterialRequest = React.lazy(() => import("../pages/Material/MaterialRequest/MaterialRequest"));
const ServiceRequest = React.lazy(() => import("../pages/Service/ServiceRequest/ServiceRequest"));
const MyMRDashboard = React.lazy(() => import("../pages/Material/MyMaterialRequest/index"));
const MySRDashboard = React.lazy(() => import("../pages/Service/MyServiceRequest/index"));
const MyMaterialRequest = React.lazy(() => import("../pages/Material/MyMaterialRequest/myMaterialRequest"));
const MyServiceRequest = React.lazy(() => import("../pages/Service/MyServiceRequest/myServiceRequest"));
const DeptMRDashboard = React.lazy(() => import("../pages/Material/DeptMaterialRequest/index"));
const DeptSRDashboard = React.lazy(() => import("../pages/Service/DeptServiceRequest"));
const DeptMaterialRequest = React.lazy(() => import("../pages/Material/DeptMaterialRequest/DeptMaterialRequest"));
const DeptServiceRequest = React.lazy(() => import("../pages/Service/DeptServiceRequest/DeptServiceRequest"));
const AllMRDashboard = React.lazy(() => import("../pages/Material/AllMaterialRequest/index"));
const AllServiceRequestDashboard = React.lazy(() => import("../pages/Service/AllServiceRequest/index"));
const AllMaterialRequest = React.lazy(() => import("../pages/Material/AllMaterialRequest/MaterialRequestView"));
const ServiceRequestView = React.lazy(() => import("../pages/Service/AllServiceRequest/ServiceRequestView"));

const NewPurchaseIndentRequest = React.lazy(() => import("../pages/PurchaseIndent/NewPurchaseRequest/NewPurchaseRequest"));
const NewSRPurchaseIndentRequest = React.lazy(() => import("../pages/SRPurchaseIndent/NewSRPurchaseRequest/NewSRPurchaseRequest"));
const MyPurchaseIndentDashboard = React.lazy(() => import("../pages/PurchaseIndent/MyPurchaseIndent/index"));
const MySRPurchaseIndentDashboard = React.lazy(() => import("../pages/SRPurchaseIndent/MyPurchaseIndent/index"));
const PurchaseIndentRequest = React.lazy(() => import("../pages/PurchaseIndent/MyPurchaseIndent/PurchaseIndentRequest"));
const SRPurchaseIndentRequest = React.lazy(() => import("../pages/SRPurchaseIndent/MyPurchaseIndent/PurchaseIndentRequest"));
const HodPurchaseIndentDashboard = React.lazy(() => import("../pages/PurchaseIndent/HodPurchaseIndent/index"));
const SRHodPurchaseIndentDashboard = React.lazy(() => import("../pages/SRPurchaseIndent/HodPurchaseIndent/index"));
const HodPurchaseIndentRequest = React.lazy(() => import("../pages/PurchaseIndent/HodPurchaseIndent/HodPurchaseIndentRequest"));
const HodSRPurchaseIndent = React.lazy(() => import("../pages/SRPurchaseIndent/HodPurchaseIndent/HodPurchaseIndentRequest"));

const RequestForQuotationDashboard = React.lazy(() => import("../pages/RequestForQuotation/index"));
const SRRequestForQuotation = React.lazy(() => import("../pages/SRRequestForQuotation/index"));
const NewRequestForQuotation = React.lazy(() => import("../pages/RequestForQuotation/NewRequestForQuotation/NewRequestForQuotation"));
const NewSRRequestForQuotation = React.lazy(() => import("../pages/SRRequestForQuotation/NewSRRequestForQuotation/NewSRRequestForQuotation"));
const RequestForQuotation = React.lazy(() => import("../pages/RequestForQuotation/RequestForQuotationTask/RequestForQuotation"));
const SRRequestForQuotationView = React.lazy(() => import("../pages/SRRequestForQuotation/SRRequestForQuotationTask/SRRequestForQuotation"));

const QuotationDashboard = React.lazy(() => import("../pages/Quotation/index"));
const SRQuotationDashboard = React.lazy(() => import("../pages/SRQuotation/index"));
const NewQuotation = React.lazy(() => import("../pages/Quotation/NewQuotation/NewQuotation"));
const NewSRQuotation = React.lazy(() => import("../pages/SRQuotation/NewSRQuotation/NewSRQuotation"));
const Quotation = React.lazy(() => import("../pages/Quotation/QuotationTask/Quotation"));
const SRQuotation = React.lazy(() => import("../pages/SRQuotation/QuotationTask/Quotation"));
const NewWorkOrder = React.lazy(() => import("../pages/SRPurchaseOrder/NewWorkOrder/NewSRQuotation"));
const CompareQuotationDashboard = React.lazy(() => import("../pages/CompareQuotation/index"));
const SRCompareQuotationDashboard = React.lazy(() => import("../pages/SRCompareQuotation/index"));
const NewCompareQuotation = React.lazy(() => import("../pages/CompareQuotation/NewCompareQuotation/NewCompareQuotation"));
const NewSRCompareQuotation = React.lazy(() => import("../pages/SRCompareQuotation/NewSRCompareQuotation/NewSRCompareQuotation"));
const CompareQuotation = React.lazy(() => import("../pages/CompareQuotation/CompareQuotationTask/CompareQuotation"));
const SRCompoareQuotation = React.lazy(() => import("../pages/SRCompareQuotation/SRCompareQuotationTask/CompareQuotation"));

const PurchaseOrderDashboard = React.lazy(() => import("../pages/PurchaseOrder/index"));
const SRPurchaseOrder = React.lazy(() => import("../pages/SRPurchaseOrder/index"));
const PurchaseOrder = React.lazy(() => import("../pages/PurchaseOrder/PurchaseOrderTask/PurchaseOrder"));
const SRPurchaseOrderView = React.lazy(() => import("../pages/SRPurchaseOrder/PurchaseOrderTask/PurchaseOrder"));
const PurchaseOrderEdit = React.lazy(() => import("../pages/PurchaseOrder/PurchaseOrderTask/PurchaseOrderEdit"));

const InGatePassDashboard = React.lazy(() => import("../pages/ingatepass/index"));
const InGatePass = React.lazy(() => import("../pages/ingatepass/InGatePassTask/InGatePass"));
const NewInGatePass = React.lazy(() => import("../pages/ingatepass/NewInGatePass/NewInGatePass"));

const UserProfile = React.lazy(() => import("../pages/UserProfile/UserProfile"));
const ChangePassword = React.lazy(() => import("../pages/UserProfile/ChangePassword"));
const SystemSettings = React.lazy(() => import("../pages/System/SystemSettings"));
const ExportCSV = React.lazy(() => import("../pages/ImportExport/export-csv"));
const ImportCSV = React.lazy(() => import("../pages/ImportExport/import-csv"));

const MastersDashboard = React.lazy(() => import("../pages/MastersDashboard/Index"));
const Companysetting = React.lazy(() => import("../pages/CompanySettings/CompanyDetails"));
const Companylist = React.lazy(() => import("../pages/CompanySettings/UsersProfile/Index"));
const AddProfile = React.lazy(() => import("../pages/CompanySettings/UsersProfile/AddProfile/Index"));
const EmailSMS = React.lazy(() => import("../pages/CompanySettings/EmailSMS"));
const ImportData = React.lazy(() => import("../pages/CompanySettings/ImportData/ImportData"));
const Yourdevices = React.lazy(() => import("../pages/CompanySettings/yourdevices/yourdevices"));
const SecurityDashboard = React.lazy(() => import("../pages/CompanySettings/SecurityDashboard/SecurityDashboard"));

// Master pages
const Companys = React.lazy(() => import("../pages/Companys/Companys"));
const Menus = React.lazy(() => import("../pages/MastersDashboard/Menus/Menu"));
const MenuItems = React.lazy(() => import("../pages/MastersDashboard/MenuItems/MenuItems"));
const departments = React.lazy(() => import("../pages/MastersDashboard/Departments/Departments"));
const locations = React.lazy(() => import("../pages/MastersDashboard/Locations/Locations"));
const quality = React.lazy(() => import("../pages/MastersDashboard/quality/Quality"));
const Sublocations = React.lazy(() => import("../pages/MastersDashboard/SubLocations/SubLocations"));
const OrderLocations = React.lazy(() => import("../pages/MastersDashboard/OrderLocations/OrderLocations"));
const ProductGroup = React.lazy(() => import("../pages/MastersDashboard/ProductGroup/ProductGroup"));
const Products = React.lazy(() => import("../pages/MastersDashboard/Products/Products"));
const AddProducts = React.lazy(() => import("../pages/MastersDashboard/Products/AddProducts"));
const AddProductsQuality = React.lazy(() => import("../pages/MastersDashboard/productQuality/AddProductQuality"));
const Vendors = React.lazy(() => import("../pages/MastersDashboard/Vendors/Vendors"));
const Category = React.lazy(() => import("../pages/MastersDashboard/Category/Category"));
const Section = React.lazy(() => import("../pages/MastersDashboard/Section/Section"));
const BasicUnit = React.lazy(() => import("../pages/MastersDashboard/BasicUnit/BasicUnit"));
const Taxs = React.lazy(() => import("../pages/MastersDashboard/Taxs/Taxs"));
const PrefixCode = React.lazy(() => import("../pages/MastersDashboard/PrefixCode/PrefixCode"));
const AddOrderLocations = React.lazy(() => import("../pages/MastersDashboard/OrderLocations/AddOrderLocations"));
const AddOrderLocationTemplate = React.lazy(() => import("../pages/MastersDashboard/OrderLocationTemplate/Add.OrderLocationTemplate"));
const OrderLocationTemplate = React.lazy(() => import("../pages/MastersDashboard/OrderLocationTemplate/OrderLocationTemplate"));
const AddQuality = React.lazy(() => import("../pages/MastersDashboard/quality/addQuality"));
const ProductQuality = React.lazy(() => import("../pages/MastersDashboard/productQuality/ProductQuality"));

// Vendor
const VendorLogin = React.lazy(() => import("../pages/VendorQuotation/VendorLogin"));
const VendorQuotationLayout = React.lazy(() => import("../pages/VendorQuotation/VendorQuotationindex"));
const VendorQuotationtReport = React.lazy(() => import("../pages/VendorQuotation/VendorQuotationReportDocument"));
const VendorPO = React.lazy(() => import("../pages/VendorPO/VendorPOReportDocument"));

// Reports
const ReportsDashboard = React.lazy(() => import("../pages/Reports/ReportsDashboard"));
const MRReports = React.lazy(() => import("../pages/Reports/MaterialRequest/MRReports"));
const SRReports = React.lazy(() => import("../pages/Reports/ServiceRequest/SRReports"));
const MRReportList = React.lazy(() => import("../pages/Reports/MaterialRequest/MRReportList"));
const SRReportList = React.lazy(() => import("../pages/Reports/ServiceRequest/SRReportList"));
const MRReportDocument = React.lazy(() => import("../pages/Reports/MaterialRequest/MRReportDocument"));
const SRReportDocument = React.lazy(() => import("../pages/Reports/ServiceRequest/SRReportDocument"));
const PIReports = React.lazy(() => import("../pages/Reports/PurchaseIndent/PIReports"));
const PIReportList = React.lazy(() => import("../pages/Reports/PurchaseIndent/PIReportList"));
const MRTimelLineReports = React.lazy(() => import("../pages/Reports/MRTimeLineReport/MRTimeLineReport"));
const SRTimelLineReports = React.lazy(() => import("../pages/Reports/SRTimeLineReport/SRTimeLineReport"));
const MRTimelLineReportList = React.lazy(() => import("../pages/Reports/MRTimeLineReport/MRTimeLineList"));
const SRTimelLineReportList = React.lazy(() => import("../pages/Reports/SRTimeLineReport/SRTimeLineList"));
const PIReportDocument = React.lazy(() => import("../pages/Reports/PurchaseIndent/PIReportDocument"));
const MRTimelLineReportDocument = React.lazy(() => import("../pages/Reports/MRTimeLineReport/MRTimeLineReportDoc"));
const SRTimelLineReportDocument = React.lazy(() => import("../pages/Reports/SRTimeLineReport/SRTimeLineReportDoc"));
const SIReports = React.lazy(() => import("../pages/Reports/ServiceIndent/SIReports"));
const SIReportList = React.lazy(() => import("../pages/Reports/ServiceIndent/SIReportList"));
const SIReportDocument = React.lazy(() => import("../pages/Reports/ServiceIndent/SIReportDocument"));
const RFQReports = React.lazy(() => import("../pages/Reports/RequestForQuotation/RFQReports"));
const RFQToPPReports = React.lazy(() => import("../pages/Reports/RFQPendingReport/RFQPendingReport"));
const RFQToPPReportsList = React.lazy(() => import("../pages/Reports/RFQPendingReport/RFQPendingReportList"));
const RFQReportList = React.lazy(() => import("../pages/Reports/RequestForQuotation/RFQReportList"));
const RFQReportDocument = React.lazy(() => import("../pages/Reports/RequestForQuotation/RFQReportDocument"));
const RFQVendorWiseReportDocument = React.lazy(() => import("../pages/Reports/RequestForQuotation/RFQVendorWiseReport"));
const SRRFQReports = React.lazy(() => import("../pages/Reports/SRRequestForQuotation/SRRFQReports"));
const SRRFQReportList = React.lazy(() => import("../pages/Reports/SRRequestForQuotation/SRRFQReportList"));
const SRReportDocument2 = React.lazy(() => import("../pages/Reports/SRRequestForQuotation/SRRFQReportDocument"));
const QReports = React.lazy(() => import("../pages/Reports/Quotation/QuotationReports"));
const QReportList = React.lazy(() => import("../pages/Reports/Quotation/QuotationReportList"));
const QReportDocument = React.lazy(() => import("../pages/Reports/Quotation/QuotationReportDocument"));
const SRQReport = React.lazy(() => import("../pages/Reports/SRQuotation/SRQuotationReports"));
const SRQReportList = React.lazy(() => import("../pages/Reports/SRQuotation/SRQuotationReportList"));
const SRQuotationReportDocument = React.lazy(() => import("../pages/Reports/SRQuotation/SRQuotationReportDocument"));
const UnitReport = React.lazy(() => import("../pages/Reports/UnitWisePending/UnitWiseReports"));
const UnitReportList = React.lazy(() => import("../pages/Reports/UnitWisePending/UnitWiseReportList"));
const UnitReportDocument = React.lazy(() => import("../pages/Reports/UnitWisePending/UnitWiseReportDocument"));
const CQReports = React.lazy(() => import("../pages/Reports/CompareQuotation/CQReports"));
const CQReportList = React.lazy(() => import("../pages/Reports/CompareQuotation/CQReportList"));
const CQReportDocument = React.lazy(() => import("../pages/Reports/CompareQuotation/CQReportDocument"));
const SRCQReports = React.lazy(() => import("../pages/Reports/SRCompareQuotation/SRCQReports"));
const SRCQReportList = React.lazy(() => import("../pages/Reports/SRCompareQuotation/SRCQReportList"));
const SRCQReportDocument = React.lazy(() => import("../pages/Reports/SRCompareQuotation/SRCQReportDocument"));
const POReports = React.lazy(() => import("../pages/Reports/PurchaseOrder/POReports"));
const POReportList = React.lazy(() => import("../pages/Reports/PurchaseOrder/POReportList"));
const POReportDocument = React.lazy(() => import("../pages/Reports/PurchaseOrder/POReportDocument"));
const POReportDetailedDocument = React.lazy(() => import("../pages/Reports/PurchaseOrder/POReportDetailedDocument"));
const POItemReportList = React.lazy(() => import("../pages/Reports/PurchaseOrder/POItemReportList"));
const SRPOReports = React.lazy(() => import("../pages/Reports/SRPurchaseOrder/SRPOReports"));
const SRPORTList = React.lazy(() => import("../pages/Reports/SRPurchaseOrder/SRPOReportList"));
const SRPOReportList = React.lazy(() => import("../pages/Reports/SRPurchaseOrder/SRPOReportList"));
const SRPOReportDocument = React.lazy(() => import("../pages/Reports/SRPurchaseOrder/SRPOReportDocument"));
const SRPOReportAMCDocument = React.lazy(() => import("../pages/Reports/SRPurchaseOrder/SRPOReportAMCDocument"));
const SRPOItemReportList = React.lazy(() => import("../pages/Reports/SRPurchaseOrder/SRPOItemReportList"));
const POAmendamentReports = React.lazy(() => import("../pages/Reports/POAmendamentHistory/POAmendamentReports"));
const POAmendamentReportList = React.lazy(() => import("../pages/Reports/POAmendamentHistory/POAmendamentReportList"));
const POAmendamentReportDocument = React.lazy(() => import("../pages/Reports/POAmendamentHistory/POAmendamentReportDocument"));
const IGPReports = React.lazy(() => import("../pages/Reports/IGP/IGPReports"));
const IGPReportList = React.lazy(() => import("../pages/Reports/IGP/IGPReportList"));
const IGPReportPOList = React.lazy(() => import("../pages/Reports/IGP/IGPReportPOList"));
const IGPReportDocument = React.lazy(() => import("../pages/Reports/IGP/IGPReportDocument"));
const MrItemsReports = React.lazy(() => import("../pages/Reports/MrItemStatus/MrItemsReports"));
const MrItemsReportList = React.lazy(() => import("../pages/Reports/MrItemStatus/MrItemsReportList"));
const VendorReports = React.lazy(() => import("../pages/Reports/VendorList/VendorReports"));
const VendorReportsList = React.lazy(() => import("../pages/Reports/VendorList/VendorReportList"));
const RfqPendingReports = React.lazy(() => import("../pages/Reports/RfqPendingItems/RfqPendingReports"));
const RfqPendingReportList = React.lazy(() => import("../pages/Reports/RfqPendingItems/RfqPendingReportList"));
const ItemReports = React.lazy(() => import("../pages/Reports/ItemWise/ItemReports"));
const ItemReportList = React.lazy(() => import("../pages/Reports/ItemWise/ItemReportList"));
const ProductStockReports = React.lazy(() => import("../pages/Reports/ProductStockReport/ProductStockReports"));
const ProductStockReportList = React.lazy(() => import("../pages/Reports/ProductStockReport/ProductStockReportList"));
const StoreReports = React.lazy(() => import("../pages/Reports/StoreReport/StoreReports"));
const StoreReportList = React.lazy(() => import("../pages/Reports/StoreReport/StoreReportList"));

// Audit Report
const AuditReport = React.lazy(() => import("../pages/Audit_Report/AuditReports"));
const AuditReportCard = React.lazy(() => import("../pages/Audit_Report/AuditReportCard_View"));

const CompareQuotationReportDocument = React.lazy(() => import("../pages/CompareQuotation/CompareQuotationTask/CompareQuotationReportDocument"));

const authProtectedRoutes = [
	{ path: "/dashboard", component: Dashboard },

	{ path: "/mrdashboard1", component: MyMRDashboard },
	{ path: "/srdashboard1", component: MySRDashboard },
	{ path: "/newmaterialrequest/:id", component: NewMaterialRequest },
	{ path: "/newservicerequest/:id", component: NewServiceRequest },
	{ path: "/materialrequest1/:id", component: MyMaterialRequest },
	{ path: "/servicerequest1/:id", component: MyServiceRequest },

	{ path: "/mrdashboard", component: MaterialRequestDashboard },
	{ path: "/srdashboard", component: ServiceRequestDashboard },
	{ path: "/MaterialRequest/:id", component: MaterialRequest },
	{ path: "/ServiceRequest/:id", component: ServiceRequest },

	{ path: "/mrdashboard2", component: DeptMRDashboard },
	{ path: "/srdashboard2", component: DeptSRDashboard },
	{ path: "/materialrequest2/:id", component: DeptMaterialRequest },
	{ path: "/servicerequest2/:id", component: DeptServiceRequest },

	{ path: "/allmrdashboard", component: AllMRDashboard },
	{
		path: "/allservicerequestdashboard",
		component: AllServiceRequestDashboard,
	},
	{ path: "/materialrequest3/:id", component: AllMaterialRequest },
	{ path: "/servicerequest3/:id", component: ServiceRequestView },
	{ path: "/compareQutdoc/:id", component: CompareQuotationReportDocument },

	{
		path: "/newpirequest/:id",
		component: NewPurchaseIndentRequest,
	},
	{
		path: "/newsrpirequest/:id",
		component: NewSRPurchaseIndentRequest,
	},
	{ path: "/pidashboard", component: MyPurchaseIndentDashboard },
	{ path: "/srpidashboard", component: MySRPurchaseIndentDashboard },
	{ path: "/pirequest/:id", component: PurchaseIndentRequest },
	{ path: "/srpirequest/:id", component: SRPurchaseIndentRequest },
	{ path: "/pidashboard1", component: HodPurchaseIndentDashboard },
	{ path: "/srpidashboard1", component: SRHodPurchaseIndentDashboard },
	{ path: "/pirequest1/:id", component: HodPurchaseIndentRequest },
	{ path: "/srrequest1/:id", component: HodSRPurchaseIndent },
	{
		path: "/rfqdashboard",
		component: RequestForQuotationDashboard,
	},
	{
		path: "/srrfqdashboard",
		component: SRRequestForQuotation,
	},
	{ path: "/newrfq/:id", component: NewRequestForQuotation },
	{ path: "/newsrrfq/:id", component: NewSRRequestForQuotation },
	{ path: "/rfq/:id", component: RequestForQuotation },
	{ path: "/srfq/:id", component: SRRequestForQuotationView },
	{ path: "/quotationdashboard", component: QuotationDashboard },
	{ path: "/srquotationdashboard", component: SRQuotationDashboard },
	{ path: "/NewQuotation/:id", component: NewQuotation },
	{ path: "/NewSRQuotation/:id", component: NewSRQuotation },
	{ path: "/NewWorkOrder/:id", component: NewWorkOrder },
	{ path: "/Quotation/:id", component: Quotation },
	{ path: "/SRQuotation/:id", component: SRQuotation },
	{
		path: "/CompareQuotationDashboard",
		component: CompareQuotationDashboard,
	},
	{
		path: "/SRCompareQuotationDashboard",
		component: SRCompareQuotationDashboard,
	},
	{ path: "/NewCompareQuotation/:id", component: NewCompareQuotation },
	{ path: "/NewSrCompareQuotation/:id", component: NewSRCompareQuotation },
	{ path: "/CompareQuotation/:id", component: CompareQuotation },
	{ path: "/SRCompareQuotation/:id", component: SRCompoareQuotation },

	{ path: "/PurchaseOrderDashboard", component: PurchaseOrderDashboard },
	{ path: "/SrPurchaseOrderDashboard", component: SRPurchaseOrder },
	{ path: "/PurchaseOrder/:id", component: PurchaseOrder },
	{ path: "/SrPurchaseOrder/:id", component: SRPurchaseOrderView },
	{ path: "/PurchaseOrderupdate/:id", component: PurchaseOrderEdit },

	{ path: "/igpdashboard", component: InGatePassDashboard },
	{ path: "/ingatepass/:id", component: InGatePass },
	{ path: "/newigp/:id", component: NewInGatePass },

	{ path: "/UserProfile", component: UserProfile },
	{ path: "/ChangePassword", component: ChangePassword },
	{ path: "/SystemSettings", component: SystemSettings },
	{ path: "/ExportCSV", component: ExportCSV },
	{ path: "/ImportCSV", component: ImportCSV },

	{ path: "/MastersDashboard", component: MastersDashboard },
	{ path: "/Getcompany", component: Companysetting },

	{ path: "/Users", component: Companylist },
	{ path: "/AddProfile/:id", component: AddProfile },
	{ path: "/EmailSMS", component: EmailSMS },
	{ path: "/ImportData", component: ImportData },
	{ path: "/yourdevices", component: Yourdevices },
	{ path: "/SecurityDashboard", component: SecurityDashboard },

	// Master pages
	{ path: "/Companys", component: Companys },
	{ path: "/Menus", component: Menus },
	{ path: "/MenuItems", component: MenuItems },
	{ path: "/Departments", component: departments },
	{ path: "/Locations", component: locations },
	{ path: "/quality", component: quality },
	{ path: "/product/quality", component: ProductQuality },
	{ path: "/SubLocations", component: Sublocations },
	{ path: "/OrderLocations", component: OrderLocations },
	{ path: "/OrderLocationTemplate", component: OrderLocationTemplate },
	{ path: "/AddOrderLocations/:id", component: AddOrderLocations },
	{ path: "/AddOrderLocationTemplate/:id", component: AddOrderLocationTemplate },
	{ path: "/AddQuality/:id", component: AddQuality },
	{ path: "/ProductGroup", component: ProductGroup },
	{ path: "/Products", component: Products },
	{ path: "/AddProducts/:id", component: AddProducts },
	{ path: "/AddProductsQuality/:id", component: AddProductsQuality },

	{ path: "/Vendors", component: Vendors },
	{ path: "/Category", component: Category },
	{ path: "/Section", component: Section },
	{ path: "/BasicUnit", component: BasicUnit },
	{ path: "/Taxs", component: Taxs },
	{ path: "/PrefixCode", component: PrefixCode },

	// Reports pages
	{ path: "/reports", component: ReportsDashboard },
	{ path: "/mrreport", component: MRReports },
	{ path: "/srreport", component: SRReports },
	{ path: "/mrreportlist", component: MRReportList },
	{ path: "/srreportlist", component: SRReportList },
	{ path: "/mrreportdoc/:id", component: MRReportDocument },
	{ path: "/srreportdoc/:id", component: SRReportDocument },
	{ path: "/mritemsreport", component: MrItemsReports },
	{ path: "/mritemsreportlist", component: MrItemsReportList },

	{ path: "/pireport", component: PIReports },
	{ path: "/mrtimelinereport", component: MRTimelLineReports },
	{ path: "/srtimelinereport", component: SRTimelLineReports },

	{ path: "/pireportlist", component: PIReportList },
	{ path: "/mrtimelinereportlist", component: MRTimelLineReportList },
	{ path: "/srtimelinereportlist", component: SRTimelLineReportList },
	{ path: "/pireportdoc/:id", component: PIReportDocument },
	{ path: "/mrtimelinereportdoc/:id", component: MRTimelLineReportDocument },
	{ path: "/srtimelinereportdoc/:id", component: SRTimelLineReportDocument },

	{ path: "/sireport", component: SIReports },
	{ path: "/sireportlist", component: SIReportList },
	{ path: "/sireportdoc/:id", component: SIReportDocument },

	{ path: "/rfqreport", component: RFQReports },
	{ path: "/rfqtopopendingreport", component: RFQToPPReports },
	{ path: "/rfqtopopendingreportlist", component: RFQToPPReportsList },

	{ path: "/rfqreportlist", component: RFQReportList },
	{ path: "/rfqreportdoc/:id", component: RFQReportDocument },
	{ path: "/rfqvendorwisereportdoc/:id", component: RFQVendorWiseReportDocument },

	{ path: "/srrfqreport", component: SRRFQReports },
	{ path: "/srrfqreportlist", component: SRRFQReportList },
	{ path: "/srrfqreportdoc/:id", component: SRReportDocument2 },

	{ path: "/qreport", component: QReports },
	{ path: "/qreportlist", component: QReportList },
	{ path: "/qreportdoc/:id", component: QReportDocument },

	{ path: "/srqreport", component: SRQReport },
	{ path: "/srqreportlist", component: SRQReportList },
	{ path: "/srqreportdoc/:id", component: SRQuotationReportDocument },

	{ path: "/unitreport", component: UnitReport },
	{ path: "/unitreportlist", component: UnitReportList },
	{ path: "/unitreportdoc/:id", component: UnitReportDocument },

	{ path: "/cqreport", component: CQReports },
	{ path: "/cqreportlist", component: CQReportList },
	{ path: "/cqreportdoc/:id", component: CQReportDocument },

	{ path: "/srcqreport", component: SRCQReports },
	{ path: "/srcqreportlist", component: SRCQReportList },
	{ path: "/srcqreportdoc/:id", component: SRCQReportDocument },

	{ path: "/poreport", component: POReports },
	{ path: "/poreportlist", component: POReportList },
	{ path: "/poreportdoc/:id", component: POReportDocument },
	{ path: "/podetailedreportdoc/:id", component: POReportDetailedDocument },
	{ path: "/poitemreportlist", component: POItemReportList },
	{ path: "/srporeport", component: SRPOReports },
	{ path: "/srporeportlist", component: SRPORTList },
	{ path: "/srporeportdoc/:id", component: SRPOReportDocument },
	{ path: "/srporeportamcdoc/:id", component: SRPOReportAMCDocument },
	{ path: "/srpoitemreportlist", component: SRPOItemReportList },

	{ path: "/pohistory", component: POAmendamentReports },
	{ path: "/pohistorylist/:id", component: POAmendamentReportList },
	{ path: "/pohistorydoc/:id", component: POAmendamentReportDocument },

	{ path: "/igpreport", component: IGPReports },
	{ path: "/igpreportlist", component: IGPReportList },
	{ path: "/igpreportlist2", component: IGPReportPOList },
	{ path: "/igpreportdoc/:id", component: IGPReportDocument },

	{ path: "/vendorreports", component: VendorReports },
	{ path: "/vendorreportlist", component: VendorReportsList },

	{ path: "/RfqPendingReports", component: RfqPendingReports },
	{ path: "/RfqPendingReportList", component: RfqPendingReportList },

	{ path: "/ItemReports", component: ItemReports },
	{ path: "/ItemReportList", component: ItemReportList },

	{ path: "/ProductStockReports", component: ProductStockReports },
	{ path: "/ProductStockReportList", component: ProductStockReportList },

	{ path: "/StoreReports", component: StoreReports },
	{ path: "/StoreReportList", component: StoreReportList },

	// Audit Report
	{ path: "/AuditReport", component: AuditReport },
	{ path: "/AuditReportCard", component: AuditReportCard },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
	{ path: "/forgot-password", component: ForgetPwd },
	{ path: "/register", component: Register },
	{ path: "/auth-lock-screen", component: AuthLockScreen },
];

const vendorQuotation = [
	{ path: "/vendorlogin/:token", component: VendorLogin },
	{ path: "/VendorQuotation/:token", component: VendorQuotationLayout },
	{ path: "/vendorpo/:token", component: VendorPO },
	{ path: "/vendorquotationview/:token", component: VendorQuotationtReport },
];

export { authProtectedRoutes, publicRoutes, vendorQuotation };
